export default "__VITE_ASSET__FsGH7LTZ__"